// Job Statuses
export const ACCEPTED = 'accepted'
export const STARTED = 'started'
export const READY_FOR_IMPORT = 'ready for import'
export const COMPLETE = 'complete'
export const FAILED = 'failed'
export const CANCELLED = 'cancelled'
export const EXPIRED = 'expired'

export const EXPORT_SIZE_LIMIT = 7500
export const EXPORT_JOBS_PER_USER_LIMIT = 10
